import { render, staticRenderFns } from "./WorkFlowSandbox.vue?vue&type=template&id=5c60357d&scoped=true"
import script from "./WorkFlowSandbox.vue?vue&type=script&lang=js"
export * from "./WorkFlowSandbox.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowSandbox.vue?vue&type=style&index=0&id=5c60357d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c60357d",
  null
  
)

export default component.exports